import ModalCustomDefault from './ModalCustomDefault';

import { useEffect, useState } from 'react';

import { IoMdClose } from 'react-icons/io';
import { styled, Box, Typography } from '@mui/material';
import InputNormal from '../input/InputNormal';
import validate from '../../utils/validation';
import Button from '../button/Button';

const ContentsBox = styled(Box)(props => ({
  width: '28rem',
  height: '6.5rem',
  padding: '1rem',
  backgroundColor: props.theme.palette.white.main,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  gap: '0.25rem',
  p: {
    fontWeight: 'bold',
  },
  '& > div': {
    width: '92%',
    margin: '0.325rem auto 0 auto',
    '& > p.MuiFormHelperText-root': {
      width: '100%',
      top: '3rem',
      fontSize: '0.35rem',
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: 'auto',
    },
  },
  '.MuiOutlinedInput-root': {
    padding: 0,
    '.password_icon': {
      width: '1.2rem',
      height: '1.2rem',
      right: '0.75rem',
    },
  },
  input: {
    backgroundColor: '#f7f7f7',
    textAlign: 'center',
  },
  fieldset: {
    border: 'none',
  },
}));

const CustomHeader = styled(Box)(props => ({
  width: '93%',
  margin: 'auto',
  height: '2rem',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: props.theme.palette.white.main,
  padding: '1.5rem 0',
  borderBottom: '1px solid #dfdfdf ',
  fontSize: '1rem',
  position: 'relative',
  marginBottom: '-1px',

  svg: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    right: '0',
    width: '1.3rem',
    height: '1.3rem',
    color: props.theme.palette.gray_1.main,
    cursor: 'pointer',
  },
}));

interface ModalCheckPWProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: (password: string) => void;
}

type PasswordObjType = {
  value: string;
  type: string;
  vali_type: string;
  error: boolean;
  error_text: string;
};

function ModalCheckPW(props: ModalCheckPWProps) {
  const visible = props.visible;
  const onClose = props.onClose;
  const onSubmit = props.onSubmit;

  const [passwordObj, setPasswordObj] = useState<PasswordObjType>({
    value: '',
    type: 'password',
    vali_type: 'password',
    error: false,
    error_text: '4~16자 영문 소문자, 대문자, 숫자, 특수문자 등 으로 조합하세요.',
  });

  useEffect(() => {
    if (!visible) {
      setPasswordObj({
        value: '',
        type: 'password',
        vali_type: 'password',
        error: false,
        error_text: '4~16자 영문 소문자, 대문자, 숫자, 특수문자 등 으로 조합하세요.',
      });
    }
  }, [visible]);

  const handlePassword = (e: React.ChangeEvent<HTMLInputElement>) => {
    const new_value = e.target.value.trim() === '' ? '' : e.target.value;
    passwordObj.value = new_value;
    const vali_res = validate[passwordObj.vali_type](e.target.value);
    passwordObj.error = !vali_res;
    setPasswordObj({ ...passwordObj });
  };

  const checkCode = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.code == 'Enter') {
      onSubmit(passwordObj.value);
    }
  };

  return (
    <ModalCustomDefault title='비밀번호 확인' visible={visible} onClose={onClose} header={false} overflow={false}>
      <CustomHeader>
        <Box>암호 입력</Box>
        <IoMdClose onClick={onClose} />
      </CustomHeader>
      <ContentsBox>
        <InputNormal
          type={passwordObj.type}
          value={passwordObj.value}
          // error={passwordObj.error}
          // errorText={passwordObj.error_text}
          onChange={handlePassword}
          onKeyDown={checkCode}
          usePasswordIcon={false}
        />
      </ContentsBox>
      <Button
        variant='contained'
        sx={{ width: '100%', borderRadius: 0, height: '3rem' }}
        color='green'
        onClick={() => onSubmit(passwordObj.value)}
      >
        확인
      </Button>
    </ModalCustomDefault>
  );
}

export default ModalCheckPW;
